export default __webpack_public_path__ + "static/media/blue-rocket.292a6b2b.png";